import * as React from 'react';
import NPSModal from './nps_modal';
import { shallow, ShallowWrapper } from 'enzyme';

let wrapped: ShallowWrapper;

describe('NPS Modal component', () => {
  beforeEach(() => {
    wrapped = shallow(<NPSModal rating={'8'} url={''} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
